// Shared GeoMMM constants. Kept out of GeoMMM.tsx so the Results sub-components can import
// them without creating a dependency cycle (GeoMMM.tsx imports Results, which imports these).

// OTHER_GEO is Meridian's bucket for every geo outside the modeled DMAs.
export const OTHER_GEO = 'other';

export const MODEL_BUCKET = 'tinuiti-mmm-results';

// Floor the rendered DmaMap to a workable size so it never shrinks small enough to clip its
// own paths (DmaMap draws into a viewBox tied to these dimensions). When the available area
// is smaller, the map keeps this size and its `.geo-map` box scrolls instead of clipping the
// right side. Floored to DmaMap's 1100px design width; the 600px height floor runs a little
// taller than DmaMap's 550px design height to leave vertical breathing room.
export const GEO_MAP_MIN_WIDTH = 1100;
export const GEO_MAP_MIN_HEIGHT = 600;

// TODO: these are hardcoded for an important demo on 10/28. Remove this after.
export const DMA_MAP_DEMO_COMPANY = 'tinuitisearchtest';
export const DEMO_DMAS_TO_INCLUDE = {
  532: 'Albany-Schenectady-Troy, NY',
  502: 'Binghamton, NY',
  506: 'Boston, MA (Manchester, NH)',
  514: 'Buffalo, NY',
  565: 'Elmira, NY',
  566: 'Harrisburg-Lancaster-Lebanon-York, PA',
  533: 'Hartford & New Haven, CT',
  501: 'New York, NY',
  504: 'Philadelphia, PA',
  521: 'Providence, RI-New Bedford, MA',
  538: 'Rochester, NY',
  577: 'Wilkes Barre-Scranton, PA',
  543: 'Springfield-Holyoke, MA',
  555: 'Syracuse, NY',
  526: 'Utica, NY',
  549: 'Watertown, NY'
};
